'use client'

import { forwardRef } from 'react'
import { Box } from '@mui/material'
import { Turnstile } from '@marsidev/react-turnstile'

// Types
import type { TurnstileInstance } from '@marsidev/react-turnstile'
import type { TurnstileFieldProps } from '@/types/components/molecules/field/turnstile'

const TurnstileFieldMolecule = forwardRef<TurnstileInstance | undefined, TurnstileFieldProps>((props, ref) => {
	// Props
	const { lng, action } = props

	// Variables
	const siteKey = process.env.TURNSTILE_SITE_KEY

	if (!siteKey) return null
	else
		return (
			<Box sx={{ display: 'flex', justifyContent: 'center', width: 1, '& > div': { width: 1 } }}>
				<Turnstile
					ref={ref}
					siteKey={siteKey}
					options={{
						action,
						theme: 'light',
						size: 'flexible',
						language: lng === 'en' ? 'en' : 'fa'
					}}
				/>
			</Box>
		)
})

TurnstileFieldMolecule.displayName = 'TurnstileFieldMolecule'

export default TurnstileFieldMolecule
